

let flickityInstances = [];

function setupFlickity() {
    const isMobile = window.innerWidth <= 999;
    const carousels = document.querySelectorAll('.js-main-carousel');

    if (!carousels.length) return;

    carousels.forEach((carousel, index) => {
        const existing = flickityInstances[index];

        // Destroy if Flickity exists and screen is not mobile
        if (existing && !isMobile) {
            existing.destroy();
            flickityInstances[index] = null;
        }

        // Initialize Flickity if mobile and not already initialized
        if (isMobile && !existing) {
            const flkty = new Flickity(carousel, {
                cellAlign: 'left',
                contain: true,
                watchCSS: false,
                prevNextButtons: false, // Disable arrows
                pageDots: false          // Disable dots
            });
            
            // Remove left padding when user starts dragging/sliding
            flkty.on('dragStart', function() {
                carousel.style.paddingLeft = '0px';
            });

            // Restore padding if we return to the first slide
            flkty.on('change', function(index) {
                if (index === 0) {
                    carousel.style.paddingLeft = '15px';
                } else {
                    carousel.style.paddingLeft = '0px';
                }
            });

            flickityInstances[index] = flkty;
        }
    });
}
setTimeout(() => {
    setupFlickity();
}, 100);
window.addEventListener('resize', setupFlickity);
